"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageCookieKey = getLanguageCookieKey;
function getLanguageCookieKey(tenant) {
  return `${tenant.toLowerCase()}_website#lang`;
}
